import { useRef, useState } from "react";
//import dateMatcher from "../util/dateMatcher";
import classes from "./DetailQuestion.module.css";
import FeedbackDisplayArea from "./FeedbackDisplayArea";
import optionBasedFilter from "../util/optionBasedFilter";
import { getActiveBranchIds1 } from "../util/multipleBranch/getActiveBranchId";
import { browseFeedbackBranchwise } from "../util/adminDashboard/browseFeedbackBranchwise";

export default function DetailQuestion({ questionTitle, optionArr, id }) {
  // sub data is stored in ref variable
  // console.log("render Detail Question");
  const subData = useRef();
  let subDataInSession;
  // console.log(sessionStorage.getItem("subData"));
  if (sessionStorage.getItem("subData") != undefined)
    subDataInSession = JSON.parse(sessionStorage.getItem("subData"));
  if (subDataInSession) {
    // console.log("initialising Subdata ref variable from session storage");
    subData.current = JSON.parse(sessionStorage.getItem("subData"));
  }
  // go below to understand tempOptionsAndQuestions
  let tempOptionsAndQuestion = {
    questionTitle: questionTitle,
    optionsSelected: [],
  };

  //we create an empty object to store all option title to question
  // and whether they are pressed or not. to track users choices
  optionArr.map((ele, index) => {
    let obj = { optionTitle: ele, pressed: false };

    if(index == 3)
      obj.pressed = true; //by default 4th option is selected as per requirement
    tempOptionsAndQuestion.optionsSelected[index] = obj;
  });


  /*format of TempOptionsAndQuestion = {
  questionTitle : questionTitle,
  optionsSelected :[
  {optionTitle :"excellent",
  pressed: false
  },
   {optionTitle :"good",
  pressed: false
  }
  ]
  
}
  
  */

  //below state track out of all options which are selected or not
  const [optionsAndQuestion, setOptionsAndQuestion] = useState(
    tempOptionsAndQuestion
  );
  const [data, setData] = useState(optionBasedFilter(subData.current, optionsAndQuestion));

  //this function gets activated when user selects or deselects any option
 console.log("options and question in detail question component");
 console.log(optionsAndQuestion);
 
  function optionCheckHandler(e) {
    e.preventDefault();

    //rather than actual string. we are using index number of that option to question
    let index = e.target.id;

    setOptionsAndQuestion((prev) => {
      let arr = JSON.parse(JSON.stringify(prev)); //deep copying state array
      arr.optionsSelected[index].pressed = !prev.optionsSelected[index].pressed;
      //console.log(arr.optionsSelected[index].pressed);

      // console.log(arr);
      let newData = optionBasedFilter(subData.current, arr);
      setData(newData);
      return arr;
    });
  }

  //To Enable user browse feedabck branch wise - via branch button on this page
  let activeBranches = getActiveBranchIds1();
  let feedbackCounterIndex = browseFeedbackBranchwise(data, activeBranches);

  return (
    <> 
      <div className={classes.questionCardContainer} id={id}>
        <h3>{questionTitle}</h3>

        <br></br>
        {optionArr.map((option, index) => {
          return (
            <a
              className={
                optionsAndQuestion.optionsSelected[index].pressed
                  ? classes.checkedOption
                  : classes.uncheckedOption
              }
              onClick={optionCheckHandler}
              id={index}
              key={option}
              href=""
            >
              {option}
            </a>
          );
        })}
        <br />
        <br />

        <FeedbackDisplayArea data={data} feedbackIndex={feedbackCounterIndex} />
      </div>
    </>
  );
}
